import type { Clip } from '../models/clip.ts'
import useUiStore from '@/shared/store/ui.store.tsx'
import useAudioStore from '@/shared/store/audio.store.tsx'

export const selectClip = (clip: Clip | undefined): void => {
  // the audio should stop playing when we close the editor
  const { selectedClip, setSelectedClip } = useUiStore.getState()

  if (clip?.id !== selectedClip?.id) {
    useAudioStore.getState().stopPlayback()
  }

  setSelectedClip(clip)
}
